import { Component, Input, OnInit, Optional } from '@angular/core'
import { FormGroup, FormGroupDirective } from '@angular/forms'
import { StationType } from '@app/shared/app.enums'

@Component({ selector: 'app-station-type', templateUrl: './station-type.component.html', styleUrls: ['./station-type.component.scss'], standalone: false })
export class StationTypeComponent implements OnInit {
  stationTypes = Object.keys(StationType)

  /** Provide control */
  @Input() provideControl: string

  /** Form group */
  @Input() form: FormGroup

  /** Item */
  @Input() item: { formControl?: FormGroup }

  /** Key name */
  @Input() key: string

  /** Title */
  @Input() title: string

  /** Additional classes */
  @Input() class: string

  constructor(@Optional() private rootFormGroup: FormGroupDirective) {}

  ngOnInit(): void {
    // Only use rootFormGroup if we're not using provideControl
    if (!this.provideControl && this.rootFormGroup) {
      this.form = this.rootFormGroup.control
    }

    if (!this.class || !this.class.length) {
      this.class += ' row-inline grid-xsm'
    }
  }

  /**
   * Check if form control exists
   * @returns True if control exists
   */
  hasFormControl(): boolean {
    if (this.provideControl) {
      return !!this.item?.formControl?.get(this.provideControl)
    }
    if (this.item?.formControl) {
      return !!this.item.formControl.get('type')
    }
    return !!this.form?.get('type')
  }

  /**
   * Get form control
   * @returns Form control
   */
  getFormControl() {
    if (this.provideControl) {
      return this.item?.formControl?.get(this.provideControl)
    }
    if (this.item?.formControl) {
      return this.item.formControl.get('type')
    }
    return this.form?.get('type')
  }
}
